import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { Client, UsState } from "src/app/models";

@Injectable({
  providedIn: "root"
})
export class StatesService
{

  private statesSubject = new BehaviorSubject<UsState[]>([]);
  public states: Observable<UsState[]> = this.statesSubject.asObservable();

  private isLoading: boolean = false;

  constructor(
    private statesClient: Client
  )
  {
    this.getStates();
  }

  public getStates()
  {
    if (this.statesSubject.value.length === 0 && !this.isLoading)
    {
      this.isLoading = true;
      this.statesClient.states().subscribe(s =>
      {
        this.statesSubject.next(s);
        this.isLoading = false;
      });
    }
  }

}
